import { render } from "./VModalImageViewer.vue?vue&type=template&id=99fefba4&ts=true"
import script from "./VModalImageViewer.vue?vue&type=script&lang=ts"
export * from "./VModalImageViewer.vue?vue&type=script&lang=ts"

import "./VModalImageViewer.vue?vue&type=style&index=0&id=99fefba4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__